module.exports = __webpack_public_path__ + "media/images/badge-fullcolor-white-fd903fc711e6686a91e211192619a7ce.png";